/**
 * Generated bundle index. Do not edit.
 */

export {ImageViewerComponent,ImageViewerConfig,CustomEvent,ImageViewerModule} from './public_api';

export {ToggleFullscreenDirective as ɵa} from './src/app/image-viewer/fullscreen.directive';